import React from 'react';
import PropTypes from 'prop-types';

class DurationWidget extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      value: null
    };
  }

  _update = () => {
    this.refresher = setTimeout(() => {
      this.setState({
        value: Date.now() / 1000
      });
      this._update();
    }, 1000);
  };

  componentDidMount() {
    // this._update();
  }

  componentWillUnmount() {
    // clearTimeout(this.refresher);
  }

  render() {
    return <div>{Math.round((this.props.value || 0) / 1000)}</div>;
  }
}

export default DurationWidget;



// WEBPACK FOOTER //
// ./src/components/DurationWidget.js